export default "__VITE_ASSET__CHy18bMl__"